import actions from '@/core/store/item-ata/realinhamento/realinhar/actions'
import state from '@/core/store/item-ata/realinhamento/realinhar/state'
import mutations from '@/core/store/item-ata/realinhamento/realinhar/mutations'

export default { actions, state, mutations }
